export { default } from "../../src/features/arrangements/screens/AdminOperationsScreen";
